import { AuthProvider } from "@pharaday/auth";
import { PHARADAY_HARBOR_URL } from "@pharaday/env";
import { ContainerModule } from "inversify";

import { ApiClientService } from "../service";

export const HarborClient = Symbol();

export const HarborClientModule = new ContainerModule(container => {
  container.bind(HarborClient).toDynamicValue(context => {
    const isTokenProvider = container.isBound(AuthProvider);
    return isTokenProvider
      ? new ApiClientService(context.get(PHARADAY_HARBOR_URL), context.get(AuthProvider))
      : new ApiClientService(context.get(PHARADAY_HARBOR_URL));
  });
});
